/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_Zh_MetaInputs */

const en_directory_submit_enrich_stage_zh_meta = /** @type {(inputs: Directory_Submit_Enrich_Stage_Zh_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate (meta)`)
};

const zh_directory_submit_enrich_stage_zh_meta = /** @type {(inputs: Directory_Submit_Enrich_Stage_Zh_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文翻译（元数据）`)
};

/**
* | output |
* | --- |
* | "Translate (meta)" |
*
* @param {Directory_Submit_Enrich_Stage_Zh_MetaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_zh_meta = /** @type {((inputs?: Directory_Submit_Enrich_Stage_Zh_MetaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_Zh_MetaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_zh_meta(inputs)
	return zh_directory_submit_enrich_stage_zh_meta(inputs)
});
export { directory_submit_enrich_stage_zh_meta as "directory.submit.enrich.stage.zh_meta" }